import { FilterPathRootNode } from '../models';

export function filterPathContainsDatasource(fitlerPath: FilterPathRootNode, dsIs: string): boolean {
  if (fitlerPath.datasourceId === dsIs) {
    return true;
  }

  return fitlerPath.relatedNodes.some((node) => filterPathContainsDatasource(node, dsIs));
}
